<template>
   <v-container style="padding-bottom: 0px">
     <div itemscope itemtype="http://schema.org/Service">
       <meta itemprop="serviceType" content="Kreation" />
     <v-layout row wrap>
       <v-flex xs12>
         <v-card>
           <div itemprop="image">
           <v-card-media
             class="edomargintop"
             alt="kreation"
             height="450px"
             :src="require('../assets/kreation.jpg')">
             <v-container fill-height>
               <v-layout fill-height>
                 <v-flex xs12 align-end flexbox positionsofteware>
                   <div itemprop="name">
                   <span class="edoheadlinekreation">Kreation</span>
                   </div>
                 </v-flex>
               </v-layout>
             </v-container>
           </v-card-media>
           </div>
         </v-card>
       </v-flex>
       <div>
         <v-breadcrumbs divider=">" class="edobread">
           <v-breadcrumbs-item
             v-for="item in items"
             :key="item.text"
             :disabled="item.disabled"
           >
             <a :href='item.route'>{{ item.text }}</a>
           </v-breadcrumbs-item>
         </v-breadcrumbs>
       </div>
     </v-layout>
       <v-container fluid grid-list-md>
         <v-layout row justify-space-around>
           <v-flex d-flex xs12 sm8 md8>
             <v-card class="edomargintop" flat>
               <v-card-text class="edoLineText">
                 <span itemprop="description">
                 Kreative Projekte beginnen, wo normale enden, denn die edologic weiß,
                 dass Gestaltung ein zielgerichteter Denkprozess ist.
                 <br><br>
                 Um intelligente Lösungen zu schaffen verbinden wir die Kreativität in der Idee un die Professionalität in der Umsetzung.
                 Mit Ihren Input und unserem Know-How bringen wir Ihre Marketingmaßnahme erfolgreich ins Ziel.
                 <br><br>
                 Die edologic ist zum einem Ihr verlässlicher Partner, wenn es um die technische und handwerkliche Kompetenz geht und zum anderem der Partner, der ein breites Spektrum an konzeptioneller Kreativität bietet.
                 Egal ob Webdesign, Retuschen oder Printdesign unser Grafiker-Team ist die richtige Wahl, denn wir greifen neue Trends und Geschmäcker auf, um nachhaltige Marketingziele zu erreichen.
                 </span>
               </v-card-text>
             </v-card>
           </v-flex>
         </v-layout>
       </v-container>

     <v-container fluid grid-list-md>
       <v-layout row wrap justify-space-around>
         <v-flex d-flex xs12 sm2 md2>
           <v-card class="edomargintop">
             <v-card-text class="edoLineTextkreation">
               • Webdesign <br>
               • Retuschen <br>
               • Printdesign <br>
               • …
             </v-card-text>
           </v-card>
         </v-flex>
       </v-layout>
     </v-container>
  </div>
     <v-container fluid grid-list-md>
       <v-layout row wrap justify-space-around>
         <v-flex d-flex xs12 sm9 md9>
           <v-card class="edomargintop">
             <div itemprop="email" itemscope itemtype="http://schema.org/PostalAddress">
             <div class="text-xs-center edomargintop linkedo">
               <v-btn outline color="grey darken-3" @click="mailto">
                 <a href="mailto:info@edologic.de" itemprop="email">
                 Anfrage stellen
                 </a>
               </v-btn>
             </div>
             </div>
           </v-card>
         </v-flex>
       </v-layout>
     </v-container>

     <v-layout row wrap>
       <v-flex xs12>
         <v-card>
           <v-card-media
             class="edomargintop"
             height="350px"
             :src="require('../assets/kreation_unten.jpg')">
           </v-card-media>
         </v-card>
       </v-flex>
     </v-layout>
     </v-container>
</template>

<script>

  export default {
    components: {},
    name: 'Kreation',
    metaInfo: {
      // title will be injected into parent titleTemplate
      title: 'Kreation – für Digitalmedien und Printmedien das beste Design',
      meta: [
        {
          name: 'description',
          content: 'Kreative Projekte, außergewöhnliches Design, bessere Ideen – die Kreation der edologic.'
        }]
    },
    data: () => ({
      items: [
        {
          text: 'Home',
          route: '/home',
          disabled: false
        },
        {
          text: 'Service',
          route: '/service',
          disabled: false
        },
        {
          text: 'Kreation',
          route: '',
          disabled: true
        }
      ]
    }),
    methods: {
      mailto () {
        window.location = 'mailto:info@edologic.de'
      }
    },
    mounted () {
      console.log('Kreation')
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Kreation.vue